import { render, staticRenderFns } from "./UserDetailPrestazione.vue?vue&type=template&id=5c7ea672&"
import script from "./UserDetailPrestazione.vue?vue&type=script&lang=js&"
export * from "./UserDetailPrestazione.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailPrestazione.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports